import Loadable from "../components/Loadable";

import Kelulusan from '../views/Murid/Kelulusan';

const Profil = Loadable(() => import('../views/Murid/Profil/Profil'));

const base_url = '';
export default [
	{ path: [base_url,'kelulusan'].join('/'), component: Kelulusan },
	{ path: [base_url, 'profil'].join('/'), component: Profil },
];